// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useState } from "react";
import { Grid } from "@mui/material";
import CompaniesSelect from "components/CustomFields/CompaniesSelect";
import Input from "components/CustomFields/Input";
import OpenTablesCard from "components/CustomCards/OpenTablesCard";

function OpenTables() {
  const [branch, setBranch] = useState(0);
  const [companyId, setCompanyId] = useState(null);
  const [searchTables, setSearchTables] = useState(null);
  const [searchDisabled, setSearchDisabled] = useState(true);
  let [counter, setCounter] = useState(0);

  const setCompanyAndEnableSearch = (e) => {
    setCompanyId(e);
    setSearchDisabled(false);
  };

  const searchOpenTables = () => {
    setCounter(counter + 1);
    setSearchTables({
      companyId: companyId,
      branch: branch,
      counter: counter++,
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox my={3}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <SoftBox lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              Φίλτρα αναζήτησης
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              Επίλεξτε φίλτρα για την αναζήτηση ανοιχτών τραπεζιών.
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
          <Grid container spacing={3} justifyContent="center" mb={3}>
            <CompaniesSelect xs={12} md={6} handler={setCompanyAndEnableSearch} />

            <Input
              xs={12}
              md={4}
              title="Αριθμός Υποκαταστήματος"
              handler={setBranch}
              type="number"
              initialValue={branch}
            />

            <Grid item xs={12} md={2}>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                height="100%"
              >
                <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ width: "100%" }}
                    onClick={searchOpenTables}
                    disabled={searchDisabled}
                  >
                    ΑΝΑΖΗΤΗΣΗ
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Grid>
          </Grid>
        </SoftBox>
        <OpenTablesCard {...searchTables} />
      </SoftBox>

      <Footer />
    </DashboardLayout>
  );
}

export default OpenTables;
